
import { useTranslations } from 'next-intl';
import { PLATE_FORM_ENUM, SHARE_PLATFORM_LIST } from "../../constants";
import { SocialIcon } from "../SocialIcon";
import DownloadIcon from "../../images/affiliate-download-icon.png";
import Image from "next/image";
import cn from "@/utils/classnames";
import useShare from "../../hooks/useShare";
import { isReferralActivityOfflineAtom } from "@/store";
import { shareToPlatform, ShareType } from "@/utils/share";
import { useAtom } from "jotai";
import toast from "react-hot-toast";
import { forwardRef, useMemo } from 'react';
import { ShareSourceEnum } from '@/types/invited';
import { Env } from '@/libs/env';
interface ShareActionGroupProps {
  className?: string;
  handleDownloadPoster: () => void;
  onShare?: (platform: string) => void;
}

const ShareActionGroup = forwardRef<any, ShareActionGroupProps>(({ className, handleDownloadPoster, onShare }, ref) => {
  const { shareUrl } = useShare();
  const [isReferralActivityOffline] = useAtom(isReferralActivityOfflineAtom);
  const t = useTranslations('referral');

  const handleShare = async (plateform: PLATE_FORM_ENUM) => {
    if (isReferralActivityOffline) {
      toast.error(t('eventEnded'));
      return;
    }
    const shareData = getShareData(plateform);
    const shareType = {
      [PLATE_FORM_ENUM.TELEGRAM]: ShareType.TELEGRAM,
      [PLATE_FORM_ENUM.WHATSAPP]: ShareType.WHATSAPP,
      [PLATE_FORM_ENUM.FACEBOOK]: ShareType.FACEBOOK,
    };
    shareToPlatform({
      url: shareData.url,
      type: shareType[plateform],
      title: shareData.title,
      text: shareData.text,
    });
    onShare?.(plateform);
  };

  const getShareData = (plateform: PLATE_FORM_ENUM) => {
    const IntlMap = {
      india: {
        shareCardTitle: t('indiaShareCardTitle'),
      },
      brazil: {
        shareCardTitle: t('brazilShareCardTitle', { brand: Env.NEXT_PUBLIC_APP_NAME }),
      },
    };
    const region = Env.REGION;
    const shareConfig = IntlMap[region] || IntlMap.india;
    const url = new URL(shareUrl);
    url.searchParams.set('s', ShareSourceEnum[plateform as any]);
    const _shareUrl = url.toString();
    return {
      title: undefined,
      text: shareConfig.shareCardTitle,
      url: _shareUrl,
      image: undefined,
    };
  };

  const platformList = useMemo(() => {
    return SHARE_PLATFORM_LIST.filter(plt => plt.platform !== PLATE_FORM_ENUM.FACEBOOK);
  }, []);

  return (
    <div className={cn("flex items-center justify-center", className)} ref={ref}>
      <div
        className={`w-12 h-12 mx-[20px] bg-dark-special rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-600 transition-colors active:scale-90`}
        onClick={handleDownloadPoster}
      >
        <Image src={DownloadIcon} alt="download" width={20} height={20} />
      </div>
      {platformList.map((item) => (
        <SocialIcon
          key={item.platform}
          type={item.platform as PLATE_FORM_ENUM}
          onShare={handleShare}
          className='mx-[20px] active:scale-90'
        />
      ))}
    </div>
  );
});

ShareActionGroup.displayName = 'ShareActionGroup';

export default ShareActionGroup;